import React from 'react';
import Header from '../component/Header';
import Footer from '../component/Footer';
import HomeSlider from '../component/HomeSlider';
import HomeDestacado from '../component/HomeDestacado';
import '../css/home.css';
class Home extends React.Component {
  constructor(props) {
    super(props);
    this.state = {locale: this.props.locale};
  }

  render() {
    return (
      <div className="wrap home">
        <Header locale={this.state.locale}></Header>
        <HomeSlider locale={this.state.locale}></HomeSlider>
        <div className="destacados">
          <HomeDestacado locale={this.state.locale} id="1"></HomeDestacado>
          <HomeDestacado locale={this.state.locale} id="2"></HomeDestacado>
        </div>
        <Footer locale={this.state.locale}></Footer>
      </div>
    );
  }
}
export default Home;


// WEBPACK FOOTER //
// ./src/pages/Home.js